import React, { useEffect, useState } from 'react';

import './App.scss';

import HistoryItemRenderer, { CommandResponse } from './HistoryItemRenderer';
import TerminalPrefix from './TerminalPrefix';
import TerminalInput, { ICommand } from './TerminalInput';

function App() {
	const [terminalHistory, setTerminalHistory] = useState<ICommand[]>([]);

	const handleEnter = (command: ICommand) => {
		setTerminalHistory([...terminalHistory, command]);
	};

	useEffect(() => {
		window.scroll(0, window.innerHeight);
	}, [terminalHistory.length]);

	return (
		<main className="App">
			<h1 className="sr-only">evanthibodeau.com</h1>

			<div aria-live="polite" className="sr-only">
				{terminalHistory.length > 0 && (
					<CommandResponse
						historyItem={
							terminalHistory[terminalHistory.length - 1]
						}
					/>
				)}
			</div>

			{terminalHistory.map((historyItem, i) => (
				<HistoryItemRenderer historyItem={historyItem} key={i} />
			))}

			<div className="row">
				<TerminalPrefix />

				<TerminalInput onEnter={handleEnter} />
			</div>
		</main>
	);
}

export default App;
